import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const sociteyWingList = createAsyncThunk(
  "sociteyWingList",
  async (id) => {
    try {
      const cookies = new Cookies();
      const token = cookies.get("token");

      const response = await AxiosInstance.get(
        `${API_KEY}/api/society/wing-list/${id}`,

        {
          headers: {
            Authorization: `Barear ${token}`,
          },
          "Content-Type": "application/json",
        }
      );

      return response;
    } catch (error) {
      if (error.response) {
        throw error.response.data.message;
      } else {
        throw error;
      }
    }
  }
);

const initialState = {
  isLoading: false,
  sociteyWingListData: null,
  isError: false,
  errorMessage: "",
};
const sociteyWingListSlice = createSlice({
  name: "sociteyWingList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(sociteyWingList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(sociteyWingList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.sociteyWingListData = action.payload;
    });
    builder.addCase(sociteyWingList.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default sociteyWingListSlice.reducer;
